<header class="header">
  <div class="headerContainer">
    <span (click)="toggleMenu()" class="headerContentLeft">
      <img
        src="assets/icons/menu.svg"
        class="iconSmall"
        alt="menu"
        [class.hide]="isMenuOpen"
      />
      <img
        src="assets/icons/close.svg"
        class="iconSmall"
        alt="menu close"
        [class.hide]="!isMenuOpen"
      />
    </span>
    <span>
      <a routerLink="/search">
        <img src="assets/icons/brand.svg" class="iconBrand" alt="Toreta now" />
      </a>
    </span>
    <a
      routerLink="/sign-in/phone-number"
      *ngIf="!isSignedIn()"
      class="headerContentRight"
    >
      ログイン
    </a>

    <a
      *ngIf="isSignedIn()"
      class="headerContentRight"
      (click)="onClickSignOutLink()"
    >
      ログアウト
    </a>
  </div>

  <div class="headerMenuContainer">
    <ul [class.hide]="!isMenuOpen" class="headerMenu">
      <li
        [ngClass]="{
          headerMenuItem: true,
          hide: !isSignedIn(),
          openSubMenu: subMenuVisivblity.settings
        }"
      >
        <div (click)="toggleSubMenu('settings')" class="headerMenuItemLabel">
          <img
            src="assets/icons/settings.svg"
            class="iconSmall"
            alt="settings"
          />
          <span class="mainMenuItemLabel">設定</span>
          <img
            src="assets/icons/pull-d.svg"
            class="iconSmall indicator"
            [class.up]="subMenuVisivblity.settings"
          />
        </div>

        <ul class="headerMenu sub" [class.hide]="!subMenuVisivblity.settings">
          <li class="headerMenuItem sub">
            <a routerLink="/account/edit">アカウント情報変更</a>
          </li>
          <li class="headerMenuItem sub">
            <a routerLink="/profile/edit">プロフィール変更</a>
          </li>
          <li class="headerMenuItem sub">
            <a routerLink="/withdraw">退会手続き</a>
          </li>
        </ul>
      </li>

      <li class="headerMenuItem" [class.hide]="!isSignedIn()">
        <img
          src="assets/icons/list-gray.svg"
          class="iconSmall"
          alt="question"
        />
        <a routerLink="/reservations" class="mainMenuItemLabel">予約履歴</a>
      </li>

      <li class="headerMenuItem">
        <img
          src="assets/icons/information.svg"
          class="iconSmall"
          alt="question"
        />
        <a
          [href]="newsURL"
          class="mainMenuItemLabel"
          target="_blank"
          rel="noopener"
          >お知らせ</a
        >
      </li>

      <li class="headerMenuItem" [class.openSubMenu]="subMenuVisivblity.help">
        <div (click)="toggleSubMenu('help')" class="headerMenuItemLabel">
          <img
            src="assets/icons/question.svg"
            class="iconSmall"
            alt="question"
          />
          <span class="mainMenuItemLabel">ヘルプとサポート</span>

          <img
            src="assets/icons/pull-d.svg"
            class="iconSmall indicator"
            [class.up]="subMenuVisivblity.help"
          />
        </div>

        <ul class="headerMenu sub" [class.hide]="!subMenuVisivblity.help">
          <li class="headerMenuItem sub">
            <a [href]="faqURL" target="_blank" rel="noopener">よくある質問</a>
          </li>
          <li class="headerMenuItem sub">
            <a [href]="usageURL" target="_blank" rel="noopener">使い方</a>
          </li>
          <li class="headerMenuItem sub">
            <a [href]="contactURL" target="_blank" rel="noopener"
              >お問い合わせ</a
            >
          </li>
        </ul>
      </li>

      <li class="headerMenuItem" [class.openSubMenu]="subMenuVisivblity.about">
        <div (click)="toggleSubMenu('about')" class="headerMenuItemLabel">
          <img src="assets/icons/toreta.svg" class="iconSmall" alt="about" />
          <span class="mainMenuItemLabel">トレタnowについて</span>

          <img
            src="assets/icons/pull-d.svg"
            class="iconSmall indicator"
            [class.up]="subMenuVisivblity.about"
          />
        </div>

        <ul class="headerMenu sub" [class.hide]="!subMenuVisivblity.about">
          <li class="headerMenuItem sub">
            <a [href]="siteURL" target="_blank" rel="noopener">公式サイト</a>
          </li>
          <li class="headerMenuItem sub">
            <a [href]="corporateURL" target="_blank" rel="noopener">運営会社</a>
          </li>
          <li class="headerMenuItem sub">
            <a [href]="termURL" target="_blank" rel="noopener">利用規約</a>
          </li>
          <li class="headerMenuItem sub">
            <a [href]="privacyURL" target="_blank" rel="noopener"
              >個人情報の取り扱い</a
            >
          </li>
          <li class="headerMenuItem sub">
            <a [href]="contactStoreURL" target="_blank" rel="noopener"
              >導入ご検討の店舗さまはこちら</a
            >
          </li>
          <li class="copyright">© {{ year }} Toreta,Inc.</li>
        </ul>
      </li>
    </ul>
  </div>
</header>

<div class="modal" *ngIf="showSignOutModal">
  <div class="modalOverlay" (click)="onCancelSignOut()"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <h5 class="modalContentTitle">
        ログアウト
      </h5>
      <p>
        ログアウトしてよろしいですか?
      </p>
    </div>
    <div class="modalControl">
      <a (click)="onCancelSignOut()">キャンセル</a>
      <a (click)="onConfirmSignOut()" class="danger">OK</a>
    </div>
  </div>
</div>

<div *ngIf="isMenuOpen" (click)="closeMenu()" class="headerOverlay"></div>
<div class="headerPad"></div>
